import { z } from 'zod';
/**
 * Casting the same value again removes the vote (a toggle-off) rather than
 * erroring — that is what "click the up arrow again" means to a user. See
 * VoteRepository.castVote for the transactional delta logic this implies.
 */
export const castVoteSchema = z.object({
    value: z.union([z.literal(1), z.literal(-1)]),
});
export const voteResultSchema = z.object({
    score: z.number().int(),
    myVote: z.union([z.literal(1), z.literal(-1), z.null()]),
});
//# sourceMappingURL=votes.js.map